import moment from 'moment'
import ft from '../featureToggle'

export default {
  getActionLogs (VueApp, rsvpId, callback) {
    VueApp.$sdk.get('/admin/rsvp/' + rsvpId + '/logs', {
      token: VueApp.$store.state.session.sessionToken,
      order: 'created',
      orderAsc: 1
    }, res => {
      if (!res.error) {
        let actions = []
        let basicInfo = {}
        res.list.forEach(function (data) {
          basicInfo = {
            id: data.id,
            action: data.action,
            created: moment(data.created, 'X').tz('America/Los_Angeles').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, true)),
            admin: data.admin ? {
              name: `${data.admin.firstName} ${data.admin.lastName}`,
              id: data.admin.id,
              email: data.admin.email,
              phone: data.admin.phone
            } : null,
            consumer: data.contact && data.contact.type === 'consumer' ? {
              name: `${data.contact.firstName} ${data.contact.lastName}`,
              id: data.contact.ID,
              email: data.contact.email,
              phone: data.contact.phone
            } : null,
            provider: data.contact && data.contact.type === 'provider' ? {
              name: `${data.contact.firstName} ${data.contact.lastName}`,
              id: data.contact.ID,
              email: data.contact.email,
              phone: data.contact.phone
            } : null,
            recipient: data.details.driver ? {
              id: data.details.driver.ID,
              name: `${data.details.driver.firstName} ${data.details.driver.lastName}`,
              email: data.details.driver.email,
              phone: data.details.driver.phone
            } : null,
            details: data.details,
            collapsed: false
          }
          if (data.action === 'release_driver') {
            basicInfo.opted = data.details.params.charge == 1 ? true : false
          }
          switch (data.action) {
            default: actions.push({
              ...basicInfo
            })
              break
            case 'edit_rsvp':
              let fields = []
              data.details.changes.forEach(function (data2) {
                fields.push({
                  field: data2.field,
                  old: data2.old,
                  new: data2.new
                })
              })

              // Combine Flight Info
              // let pickupFlightNoIndex = fields.findIndex(x => x.field === 'flightNumber')
              // let pickupAirlineIndex = fields.findIndex(x => x.field === 'flightName')
              // if (pickupFlightNoIndex > -1 && pickupAirlineIndex > -1) {
              //   fields.push({
              //     field: 'Flight Information',
              //     old: fields[pickupAirlineIndex].old + ' ' + fields[pickupFlightNoIndex].old,
              //     new: fields[pickupAirlineIndex].new + ' ' + fields[pickupFlightNoIndex].new
              //   })
              // }
              // let dropoffFlightNoIndex = fields.findIndex(x => x.field === 'dropoffFlightNumber')
              // let dropoffAirlineIndex = fields.findIndex(x => x.field === 'dropoffFlightName')
              // if (dropoffFlightNoIndex > -1 && dropoffAirlineIndex > -1) {
              //   fields.push({
              //     field: 'Flight Information',
              //     old: fields[dropoffFlightNoIndex].old + ' ' + fields[dropoffAirlineIndex].old,
              //     new: fields[dropoffFlightNoIndex].new + ' ' + fields[dropoffAirlineIndex].new
              //   })
              // }

              let pickupNumber = fields.findIndex(x => x.field === 'flightNumber')
              let pickupAirline = fields.findIndex(x => x.field === 'flightName')
              let dropoffNumber = fields.findIndex(x => x.field === 'dropoffFlightNumber')
              let dropoffAirline = fields.findIndex(x => x.field === 'dropoffFlightName')

              let swapPosition = function (arr, indexA, indexB) {
                let temp = arr[indexA]
                arr[indexA] = arr[indexB]
                arr[indexB] = temp
              }

              if (pickupNumber !== -1 && pickupAirline !== -1) {
                swapPosition(fields, pickupNumber, pickupAirline)
              }
              if (dropoffAirline !== -1 && dropoffNumber !== -1) {
                swapPosition(fields, dropoffNumber, dropoffAirline)
              }

              if (data.details.params.freeChange) {
                fields.unshift({
                  field: 'waive_payment',
                  old: false,
                  new: true
                })
              }

              actions.push({
                ...basicInfo,
                fields
              })
              break
          }
        })

        VueApp.$store.commit('rsvpDetails/setAction', actions)
      }
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/reservation-details/action.js